import React from "react";

import { Field } from "components";
import { BaseInput } from "components/Common/Field/BaseInput";

export const InputText = (props: InputTextProps): JSX.Element => <BaseInput {...props} type={props.type || "text"} />;

export const FieldText = ({ error, inputProps, ...props }: FieldTextProps): JSX.Element => (
  <Field error={error} labelFor={inputProps.name} {...props}>
    <InputText hasError={!!error} {...inputProps} />
  </Field>
);
